<div class="breakPoint">
	<slot />
</div>

<style>
	@media screen and (min-width: 1280px) {
		.breakPoint {
			position: relative;
			block-size: 100%;
			inline-size: 1280px;
			margin-block: 0;
			margin-inline: auto;
			padding-block: 0;
			padding-inline: var(--gutterMedium);
		}
	}

	@media screen and (min-width: 1080px) and (max-width: 1279px) {
		.breakPoint {
			position: relative;
			block-size: 100%;
			inline-size: 1080px;
			margin-block: 0;
			margin-inline: auto;
			padding-block: 0;
			padding-inline: var(--gutterMedium);
		}
	}

	@media screen and (min-width: 990px) and (max-width: 1079px) {
		.breakPoint {
			position: relative;
			block-size: 100%;
			inline-size: 990px;
			margin-block: 0;
			margin-inline: auto;
			padding-block: 0;
			padding-inline: var(--gutterMedium);
		}
	}

	@media screen and (min-width: 900px) and (max-width: 989px) {
		.breakPoint {
			position: relative;
			block-size: 100%;
			inline-size: 900px;
			margin-block: 0;
			margin-inline: auto;
			padding-block: 0;
			padding-inline: var(--gutterMedium);
		}
	}

	@media screen and (min-width: 810px) and (max-width: 899px) {
		.breakPoint {
			position: relative;
			block-size: 100%;
			inline-size: 810px;
			margin-block: 0;
			margin-inline: auto;
			padding-block: 0;
			padding-inline: var(--gutterMedium);
		}
	}

	@media screen and (min-width: 720px) and (max-width: 809px) {
		.breakPoint {
			position: relative;
			block-size: 100%;
			inline-size: 720px;
			margin-block: 0;
			margin-inline: auto;
			padding-block: 0;
			padding-inline: var(--gutterMedium);
		}
	}

	@media screen and (min-width: 630px) and (max-width: 719px) {
		.breakPoint {
			position: relative;
			block-size: 100%;
			inline-size: 630px;
			margin-block: 0;
			margin-inline: auto;
			padding-block: 0;
			padding-inline: var(--gutterMedium);
		}
	}

	@media screen and (min-width: 576px) and (max-width: 629px) {
		.breakPoint {
			position: relative;
			block-size: 100%;
			inline-size: 576px;
			margin-block: 0;
			margin-inline: auto;
			padding-block: 0;
			padding-inline: var(--gutterMedium);
		}
	}

	@media screen and (max-width: 575px) {
		.breakPoint {
			position: relative;
			block-size: 100%;
			inline-size: 100%;
			padding-block: 0;
			padding-inline: var(--gutterMedium);
		}
	}
</style>
